import { ApiRequest } from "src/models/api.request";
import GnlKullanicivarsayilanDTO from "src/models/Genel/GnlKullanicivarsayilanDTO";
import api from "src/services/core/api";

const controllerName = "GnlKullaniciVarsayilanDTO";

export const GnlKullaniciVarsayilanApi = api.injectEndpoints({
  endpoints: builder => ({
    getKullaniciVarsayilanList: builder.query<Array<GnlKullanicivarsayilanDTO>, number>({
      query: (userId) => {
        let apiReq: ApiRequest<GnlKullanicivarsayilanDTO> = {
          filters: {
            groupOperator: 'and',
            predicates: [
              { fieldName: 'fkGnlKullanici', operator: '=', value1: userId },
            ]
          },
          sorts: [{ fieldName: "id" }],
        }
        return {
          url: controllerName + "/find",
          method: "POST",
          body: apiReq
        }
      },
      providesTags: ["KullaniciVarsayilan"]
    }),
    crateKullaniciVarsayilan: builder.mutation<GnlKullanicivarsayilanDTO, GnlKullanicivarsayilanDTO>({
      query: (request) => ({
        url: controllerName,
        method: "POST",
        body: request
      }),

      invalidatesTags: ["KullaniciVarsayilan"],
      onQueryStarted(arg, { queryFulfilled, dispatch, getState, getCacheEntry, extra }) {
        queryFulfilled
          .then(res => {
            dispatch(
              GnlKullaniciVarsayilanApi.util.updateQueryData(
                "getKullaniciVarsayilanList", arg.fkGnlKullanici,
                (draft) => {
                  draft.unshift(res.data);
                }
              )
            );
          })
          .catch(res => res)
      },
    }),

    updateKullaniciVarsayilan: builder.mutation<GnlKullanicivarsayilanDTO, GnlKullanicivarsayilanDTO>({
      query: (request) => ({
        url: controllerName,
        method: "PUT",
        body: request
      }),
      invalidatesTags: ["KullaniciVarsayilan"],
      onQueryStarted(arg, { queryFulfilled, dispatch, getState, getCacheEntry, extra }) {
        queryFulfilled
          .then(res => {
            dispatch(
              GnlKullaniciVarsayilanApi.util.updateQueryData(
                "getKullaniciVarsayilanList", arg.fkGnlKullanici,
                (draft) => {
                  draft.unshift(res.data);
                }
              )
            );
          })
          .catch(res => res)
      },
    }),

    deleteKullaniciVarsayilan: builder.mutation<GnlKullanicivarsayilanDTO, number>({
      query: (request) => ({
        url: controllerName + '/' + request,
        method: "DELETE",
        body: request
      }),
      invalidatesTags: ["KullaniciVarsayilan"],
      onQueryStarted(arg, { queryFulfilled, dispatch, getState, getCacheEntry, extra }) {
        queryFulfilled
          .then(res => {
            dispatch(
              GnlKullaniciVarsayilanApi.util.updateQueryData(
                "getKullaniciVarsayilanList", arg,
                (draft) => {
                  draft.filter(f => f.id !== arg);
                }
              )
            );
          })
          .catch(res => res)
      },
    }),
  }),

})

export const {
  useGetKullaniciVarsayilanListQuery,
  useCrateKullaniciVarsayilanMutation,
  useUpdateKullaniciVarsayilanMutation,
  useDeleteKullaniciVarsayilanMutation } = GnlKullaniciVarsayilanApi;